import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, registerPackageExport, packageExports, getPackageShape, } = linkedPackage('lincd-sioc');
//# sourceMappingURL=package.js.map